import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import api from "../../utils/api";
import { registrarMenuPresenca } from "../../utils/presencePage";
import {
  caminhoForaDoPlano,
  caminhosPermitidos,
  carregarCatalogoPermissoes,
} from "../../utils/permissions";
import {
  CircleDollarSign,
  Radar,
  LayoutDashboard,
  Eye,
  Bell,
  LayoutGrid,
  ClipboardList,
  Truck,
  DollarSign,
  BarChart3,
  Download,
  Settings,
  SlidersHorizontal,
  Gauge,
  X,
  ChevronDown,
  Users,
  AirVent,
  Building2,
  UserCog,
  Car,
  Wrench,
  Tag,
  Fuel,
  Antenna,
  Boxes,
  ShoppingCart,
  Package,
  MapPin,
  MapPinned,
  Sticker,
  Wallet,
  FolderTree,
  Target,
  Banknote,
  CreditCard,
  Ban,
  Smartphone,
  ThumbsDown,
  Timer,
  MessageSquare,
  Route,
  Satellite,
  Zap,
  History,
  ClipboardCheck,
  Pause,
  Percent,
  List,
  Sparkles,
  SquareStack,
  FileBarChart,
  CalendarRange,
  Warehouse,
  CalendarClock,
  Tv,
  ShieldCheck,
  AlertTriangle,
  ReceiptText,
  Star,
  GripVertical,
  Landmark,
  ScanEye,
  MonitorDot,
  ShieldAlert,
  Clock3,
} from "lucide-react";
import { toast } from "sonner";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { MenuLevel } from "./CascadingMenu";

const navItems = [
  { path: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  {
    path: "/services",
    label: "Servi\u00e7os",
    icon: ClipboardList,
    children: [
      { path: "/services/list", label: "Listagem", icon: ClipboardList },
      { path: "/services/logistics", label: "Painel Log\u00edstico", icon: Truck, newTab: true },
      { path: "/wallboard", label: "Wallboard", icon: Tv, newTab: true },
      // Fechamento antigo (/assessment) oculto por ora.
      { path: "/services/closing", label: "Fechamento", icon: ClipboardCheck },
      { path: "/billing", label: "Faturamento", icon: ReceiptText },
      { path: "/services/captures", label: "Capturas", icon: Download },
      { path: "/services/commissions", label: "Remunera\u00e7\u00f5es", icon: Percent },
      { path: "/services/ratings", label: "Avalia\u00e7\u00f5es", icon: Star, children: [
        { path: "/services/ratings", label: "Respostas", icon: Star },
        { path: "/services/ratings/indicators", label: "Indicadores", icon: BarChart3 },
      ] },
      { path: "/reports/productivity", label: "Produtividade", icon: BarChart3, children: [
        { path: "/reports/productivity", label: "Profissionais", icon: Users },
        { path: "/reports/productivity/users", label: "Usuários", icon: UserCog },
      ] },
    ],
  },
  {
    path: "/fiscal",
    label: "Fiscal",
    icon: ReceiptText,
    children: [
      { path: "/fiscal", label: "Visão Geral", icon: Gauge },
      { path: "/fiscal/nfse", label: "NFS-e", icon: ReceiptText },
      { path: "/fiscal/profiles", label: "Perfis Fiscais", icon: SlidersHorizontal },
    ],
  },
  {
    path: "/finance",
    label: "Financeiro",
    icon: Wallet,
    children: [
      { path: "/finance/entries", label: "Lançamentos", icon: DollarSign },
      { path: "/finance/statement", label: "Extrato", icon: Landmark },
      { path: "/finance/ofx-imports", label: "Conciliação Bancária", icon: History },
    ],
  },
  {
    path: "/inventory",
    label: "Estoque",
    icon: Boxes,
    children: [
      { path: "/inventory/movements", label: "Movimentações", icon: History },
      { path: "/inventory/balances", label: "Saldos", icon: Boxes },
      { path: "/inventory/sales", label: "Vendas", icon: ShoppingCart },
      { path: "/inventory/replenishment", label: "Reposição", icon: ClipboardList },
      { path: "/inventory/products", label: "Produtos", icon: Package },
      { path: "/inventory/locations", label: "Locais", icon: MapPin },
    ],
  },
  {
    path: "/climatization",
    label: "Climatização",
    icon: AirVent,
    children: [
      { path: "/climatization", label: "Visão geral", icon: AirVent },
      { path: "/climatization/installations", label: "Instalações", icon: Building2 },
      { path: "/climatization/schedule", label: "Programação", icon: CalendarClock },
      { path: "/climatization/requests", label: "Solicitações", icon: ClipboardList },
    ],
  },
  {
    path: "/fleet",
    label: "Frota",
    icon: Warehouse,
    children: [
      { path: "/fleet/fuel", label: "Abastecimentos", icon: Fuel },
      { path: "/fleet/maintenance", label: "Manutenções", icon: Wrench },
      { path: "/fleet/maintenance/plans", label: "Planos Preventivos", icon: CalendarClock },
      { path: "/fleet/fines", label: "Multas", icon: AlertTriangle },
      { path: "/fleet/ipva", label: "IPVA", icon: CircleDollarSign },
    ],
  },
  {
    path: "/insurance",
    label: "Seguros",
    icon: ShieldCheck,
    children: [
      { path: "/insurance/policies", label: "Apólices", icon: ShieldCheck },
      { path: "/insurance/claims", label: "Sinistros", icon: AlertTriangle },
    ],
  },
  {
    path: "/settings",
    label: "Configura\u00e7\u00f5es",
    icon: Settings,
    children: [
      { path: "/settings/branding", label: "Adesivação", icon: Sticker },
      { path: "/settings/automations", label: "Automações", icon: Zap },
      { path: "/settings/ratings", label: "Avaliações", icon: Star },
      { path: "/settings/custom-fields", label: "Campos", icon: SlidersHorizontal },
      { path: "/settings/cancel-reasons", label: "Cancelamentos", icon: Ban },
      { path: "/settings/checklists", label: "Checklists", icon: ClipboardCheck },
      { path: "/settings/fuel-types", label: "Combustíveis", icon: Fuel },
      { path: "/settings/branches", label: "Filiais", icon: Building2 },
      {
        path: "/settings/finance",
        label: "Financeiro",
        icon: Wallet,
        children: [
          { path: "/settings/finance/general", label: "Geral", icon: SlidersHorizontal },
          { path: "/settings/finance/categories", label: "Categorias", icon: FolderTree },
          { path: "/settings/finance/cost-centers", label: "Centro de Custo", icon: Target },
          { path: "/settings/finance/bank-accounts", label: "Contas Bancárias", icon: Banknote },
          { path: "/settings/finance/payment-methods", label: "Formas de Pagamento", icon: CreditCard },
        ],
      },
      { path: "/settings/general", label: "Gerais", icon: Settings },
      {
        path: "/settings/mobile",
        label: "Mobile",
        icon: Smartphone,
        children: [
          { path: "/settings/quick-messages", label: "Mensagens Prontas", icon: MessageSquare },
          {
            path: "/settings/pauses",
            label: "Pausas",
            icon: Pause,
            children: [
              { path: "/settings/pauses/general", label: "Geral", icon: Settings },
              { path: "/settings/pauses/history", label: "Histórico", icon: History },
              { path: "/settings/pauses/reasons", label: "Motivos", icon: List },
            ],
          },
          { path: "/settings/rejection-reasons", label: "Recusas", icon: ThumbsDown },
          { path: "/settings/dispatch-expiration", label: "Tempo para Expirar", icon: Timer },
          { path: "/settings/speed-control", label: "Velocidade", icon: Gauge },
          { path: "/settings/mobile/view", label: "Visualização", icon: Eye },
        ],
      },
      { path: "/settings/notifications", label: "Notificações", icon: Bell },
      {
        path: "/settings/painel-logistico",
        label: "Painel Logístico",
        icon: Truck,
        children: [
          { path: "/settings/dispatch-routing", label: "Geral", icon: Route },
          { path: "/settings/trackers", label: "Rastreadores", icon: Satellite },
        ],
      },
      { path: "/settings/profiles", label: "Perfis", icon: Users },
      { path: "/settings/people", label: "Pessoas", icon: Users },
      { path: "/settings/pois", label: "Pontos de Interesse", icon: MapPinned },
      {
        path: "/portals",
        label: "Portais",
        icon: Antenna,
        children: [
          { path: "/portals/automations", label: "Integração", icon: Antenna },
          { path: "/portals/detections", label: "Acionamentos", icon: History },
        ],
      },
      { path: "/settings/tags", label: "Tags e SuperTags", icon: Tag },
      { path: "/settings/service-types", label: "Tipos de Serviços", icon: Wrench },
      { path: "/settings/users", label: "Usu\u00e1rios", icon: UserCog },
      { path: "/settings/vehicles", label: "Viaturas", icon: Car },
    ],
  },
  {
    path: "/audit",
    label: "Auditoria",
    icon: ScanEye,
    children: [
      { path: "/audit/access", label: "Acessos", icon: MonitorDot },
      { path: "/audit/alerts", label: "Alertas de Segurança", icon: ShieldAlert },
      { path: "/audit/logs", label: "Logs", icon: History },
      { path: "/audit/sessions", label: "Sessões", icon: Clock3 },
    ],
  },
  {
    path: "/analytics",
    label: "Relat\u00f3rios",
    icon: BarChart3,
    children: [
      { path: "/reports", label: "Construtor", icon: Wrench, children: [
        { path: "/reports", label: "Cart\u00f5es", icon: SquareStack },
        { path: "/panels", label: "Pain\u00e9is", icon: LayoutGrid },
        { path: "/ai-reports", label: "Prompt IA", icon: Sparkles, desativado: true, tag: "beta" },
      ] },
      { path: "/reports/ready/services", label: "Prontos", icon: FileBarChart, children: [
        { path: "/reports/ready/services", label: "Servi\u00e7os", icon: CalendarRange },
        { path: "/reports/ready/sla", label: "Tempo", icon: Timer },
        { path: "/reports/ready/billing", label: "Faturamento", icon: CircleDollarSign },
        { path: "/reports/ready/portals", label: "Portais", icon: Radar },
      ] },
    ],
  },
];

registrarMenuPresenca(navItems);

// Exportado para uso em breadcrumbs (Header.js)
export { navItems };

// Último valor conhecido dos contadores do menu (evita piscar na troca de rota).
let badgeCache = {};
let favoritosCache = null;

/**
 * Remove do menu o que o usuário não pode ver.
 *
 * Dois cortes diferentes: o plano (não contratado — vale até para acesso
 * total, e por isso vem antes) e o perfil de acesso. O corte precisa ser
 * recursivo: submenu sobrando faria o pai aparecer vazio.
 */
function filtrarMenu(lista, permitidos, user) {
  return lista
    .map((item) => {
      if (caminhoForaDoPlano(user, item.path)) return null;
      // Super admin ou equipe da plataforma em acesso de suporte no cliente.
      if (item.soSuperAdmin && user?.role !== "super_admin" && user?.impersonation?.mode !== "support") return null;
      const filhos = item.children ? filtrarMenu(item.children, permitidos, user) : null;
      if (filhos && filhos.length) return { ...item, children: filhos };
      if (item.children) return null;
      if (!permitidos) return item;
      return permitidos.has(item.path) ? item : null;
    })
    .filter(Boolean);
}


const LIMITE_FAVORITOS = 8;

// Achata o menu (já filtrado por permissões) nas telas favoritáveis: só folhas.
function telasFavoritaveis(lista, acc = new Map()) {
  lista.forEach((item) => {
    if (item.children?.length) telasFavoritaveis(item.children, acc);
    else if (!item.desativado && !acc.has(item.path)) acc.set(item.path, item);
  });
  return acc;
}


export default function Sidebar({ open, onClose, collapsed, items, darkSidebar }) {
  const location = useLocation();
  const { user } = useAuth();
  const [openMenus, setOpenMenus] = useState({});
  // Flyout do menu colapsado: abre no hover (mouse) e no clique/toque (tablet).
  const [flyout, setFlyout] = useState(null);
  const flyoutTimer = useRef(null);
  const openFlyout = (path) => { clearTimeout(flyoutTimer.current); setFlyout(path); };
  const closeFlyoutSoon = () => {
    clearTimeout(flyoutTimer.current);
    flyoutTimer.current = setTimeout(() => setFlyout(null), 180);
  };

  // Ao trocar de rota, limpa os toggles manuais para o menu da rota atual voltar a abrir sozinho.
  useEffect(() => {
    setOpenMenus({});
  }, [location.pathname]);

  // Pendências inline: Fechamento (reprovados + pendentes) e Faturamento.
  // Cache em módulo pra não piscar quando a Sidebar remonta ao trocar de rota.
  const [badges, setBadges] = useState(badgeCache);
  const [permitidos, setPermitidos] = useState(null);
  // Favoritos do menu: por usuário no banco, até 8, ordem arrastável.
  // Cache em módulo (a Sidebar remonta a cada rota) e trava de escrita até carregar,
  // senão um clique antes da resposta sobrescreveria a lista salva.
  const [favoritos, setFavoritos] = useState(favoritosCache || []);
  const [favoritosProntos, setFavoritosProntos] = useState(favoritosCache !== null);
  const [arrastando, setArrastando] = useState(null);

  useEffect(() => {
    if (!user || darkSidebar || favoritosCache !== null) return;
    api.get("/me/menu-favorites")
      .then(({ data }) => {
        favoritosCache = data.paths || [];
        setFavoritos(favoritosCache);
        setFavoritosProntos(true);
      })
      .catch(() => {});
  }, [user, darkSidebar]);

  const salvarFavoritos = (paths) => {
    favoritosCache = paths;
    setFavoritos(paths);
    api.put("/me/menu-favorites", { paths }).catch(() => {
      toast.error("Não foi possível salvar os favoritos");
    });
  };

  const alternarFavorito = (path) => {
    if (!favoritosProntos) return;
    if (favoritos.includes(path)) {
      salvarFavoritos(favoritos.filter((p) => p !== path));
      return;
    }
    if (favoritos.length >= LIMITE_FAVORITOS) {
      toast.error(`Você pode fixar até ${LIMITE_FAVORITOS} telas`);
      return;
    }
    salvarFavoritos([...favoritos, path]);
  };

  const soltarEm = (destino) => {
    if (!arrastando || arrastando === destino) return setArrastando(null);
    const lista = favoritos.filter((p) => p !== arrastando);
    const i = lista.indexOf(destino);
    lista.splice(i < 0 ? lista.length : i, 0, arrastando);
    setArrastando(null);
    salvarFavoritos(lista);
  };

  useEffect(() => {
    // No modo admin o corte de menu já vem do AdminLayout (por permissão da
    // equipe); membros da plataforma não têm perfil de acesso de tenant, e
    // aplicar aquele filtro aqui deixaria o menu vazio.
    if (!user || user.full_access || darkSidebar) return setPermitidos(null);
    carregarCatalogoPermissoes()
      .then((cat) => setPermitidos(caminhosPermitidos(cat, user)))
      .catch(() => {});
  }, [user, darkSidebar]);

  useEffect(() => {
    if (!user || darkSidebar) return;
    let ativo = true;
    const carregar = () => api.get("/nav/badges")
      .then(({ data }) => {
        badgeCache = {
          "/assessment": data.assessment || 0,
          "/services/closing": data.closing || 0,
          "/billing": data.billing || 0,
          "/climatization/requests": data.service_requests || 0,
          "/fleet/fines": data.fines || 0,
          "/fleet/ipva": data.ipva || 0,
          "/insurance/policies": data.insurance || 0,
        };
        if (ativo) setBadges(badgeCache);
      })
      .catch(() => {});
    carregar();
    const id = setInterval(carregar, 60000);
    // Telas que mudam os contadores pedem a atualização na hora.
    window.addEventListener("nav-badges:refresh", carregar);
    return () => { ativo = false; clearInterval(id); window.removeEventListener("nav-badges:refresh", carregar); };
  }, [user, darkSidebar]);

  // rem para acompanhar a densidade: 17.5rem = 280px no normal, ~227px no compacto
  const sidebarW = collapsed ? "w-20" : "w-[17.5rem]";
  // O menu usa sempre o azul escuro da marca, em qualquer tema.
  const isDark = true;

  const sidebarBg = "bg-[#111827]";
  const textActive = isDark ? "text-white" : "text-gray-900";
  const textInactive = isDark ? "text-[#e1e7ef]" : "text-gray-500";
  const hoverBg = isDark ? "hover:bg-white/5" : "hover:bg-gray-100";
  const activeBg = isDark ? "bg-white/10" : "bg-gray-100";
  const borderSep = isDark ? "border-white/10" : "border-gray-200";
  const logoText = isDark ? "text-white" : "text-gray-900";
  const subBorder = isDark ? "border-white/10" : "border-gray-200";

  // `atual` = estado efetivo exibido (considera abertura automática pela rota ativa),
  // assim o clique sempre inverte o que o usuário está vendo.
  const toggleMenu = (path, atual) => {
    setOpenMenus((prev) => ({ ...prev, [path]: !(prev[path] ?? atual) }));
  };

  // Props extras quando o item deve abrir em nova aba
  const extLinkProps = (item) =>
    item?.newTab
      ? { target: "_blank", rel: "noopener noreferrer" }
      : {};

  // Verifica recursivamente se algum descendente (em qualquer nível) tem a rota ativa
  const isChildActive = (item) => {
    if (!item?.children?.length) return false;
    return item.children.some(
      (c) => location.pathname === c.path
        || (c.path === "/panels" && location.pathname.startsWith("/panels/"))
        || (c.path?.startsWith("/reports/ready/") && location.pathname.startsWith(`${c.path}/`))
        || isChildActive(c),
    );
  };

  // Envolve um link do menu com a estrela de favoritar (aparece no hover).
  const comEstrela = (path, link) => {
    if (collapsed || darkSidebar) return link;
    const fav = favoritos.includes(path);
    return (
      <div key={path} className="group/fav relative flex items-center">
        {link}
        <button
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); alternarFavorito(path); }}
          title={fav ? "Remover dos favoritos" : "Fixar nos favoritos"}
          className={`absolute ${badges[path] > 0 ? "right-11" : "right-2"} p-1 rounded-md transition-opacity duration-150 ${
            fav
              ? "opacity-100 text-amber-400"
              : `opacity-0 pointer-events-none group-hover/fav:opacity-100 group-hover/fav:pointer-events-auto ${isDark ? "text-white/50" : "text-gray-400"} hover:text-amber-400`
          }`}
          data-testid={`sidebar-fav-toggle-${path.slice(1).replace(/\//g, "-")}`}
        >
          <Star size={11} className={fav ? "fill-current" : ""} />
        </button>
      </div>
    );
  };

  const renderFavoritos = () => {
    if (darkSidebar || !favoritos.length) return null;
    const telas = telasFavoritaveis(filtrarMenu(items || navItems, permitidos, user));
    const fixados = favoritos.map((p) => telas.get(p)).filter(Boolean);
    if (!fixados.length) return null;

    return (
      <div className={`mb-2 pb-2 border-b ${borderSep}`} data-testid="sidebar-favorites">
        {!collapsed && (
          <p className={`px-3 pb-1 text-[10px] font-semibold uppercase tracking-wider ${isDark ? "text-white/40" : "text-gray-400"}`}>
            Favoritos
          </p>
        )}
        <div className="space-y-0.5">
          {fixados.map((item) => {
            const ativo = location.pathname === item.path;
            const link = (
              <Link
                to={item.path}
                {...extLinkProps(item)}
                onClick={onClose}
                className={`flex-1 flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-all duration-200 ${
                  collapsed ? "justify-center" : ""
                } ${ativo ? `${isDark ? "bg-white/15 text-white" : "bg-gray-200 text-gray-900"} font-medium` : `${textInactive} ${hoverBg}`}`}
                data-testid={`sidebar-fav-${item.path.slice(1).replace(/\//g, "-")}`}
              >
                <item.icon size={collapsed ? 20 : 16} className="min-w-[16px]" />
                {!collapsed && <span className="truncate">{item.label}</span>}
              </Link>
            );

            if (collapsed) {
              return (
                <Tooltip key={item.path}>
                  <TooltipTrigger asChild>{link}</TooltipTrigger>
                  <TooltipContent side="right" className="font-medium">{item.label}</TooltipContent>
                </Tooltip>
              );
            }

            return (
              <div
                key={item.path}
                draggable
                onDragStart={() => setArrastando(item.path)}
                onDragOver={(e) => e.preventDefault()}
                onDrop={() => soltarEm(item.path)}
                onDragEnd={() => setArrastando(null)}
                className={`group/fav relative flex items-center rounded-lg ${
                  arrastando === item.path ? "opacity-40" : ""
                }`}
                data-testid={`sidebar-fav-row-${item.path.slice(1).replace(/\//g, "-")}`}
              >
                {link}
                <button
                  onClick={(e) => { e.preventDefault(); alternarFavorito(item.path); }}
                  title="Remover dos favoritos"
                  className="absolute right-8 p-1 rounded-md text-amber-400 hover:text-amber-500 opacity-0 pointer-events-none group-hover/fav:opacity-100 group-hover/fav:pointer-events-auto transition-opacity duration-150"
                  data-testid={`sidebar-fav-remove-${item.path.slice(1).replace(/\//g, "-")}`}
                >
                  <Star size={11} className="fill-current" />
                </button>
                <GripVertical
                  size={12}
                  className={`absolute right-2 cursor-grab opacity-0 group-hover/fav:opacity-100 transition-opacity ${isDark ? "text-white/40" : "text-gray-400"}`}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderNavItem = (item) => {
    const isActive =
      location.pathname === item.path ||
      (item.path === "/panels" && location.pathname.startsWith("/panels/")) ||
      (item.path?.startsWith("/reports/ready/") && location.pathname.startsWith(`${item.path}/`)) ||
      isChildActive(item);
    const hasChildren = item.children && item.children.length > 0;
    const isOpen = openMenus[item.path] ?? isChildActive(item);

    // Active styles: parent menu = accent color, sub-items = darker gray
    const activeStyle = isActive ? { backgroundColor: "var(--accent)", color: "#fff" } : undefined;
    const subActiveClass = isDark ? "bg-white/15 text-white" : "bg-gray-200 text-gray-900";

    // Parent with children
    if (hasChildren) {
      const parentEl = (
        <button
          onClick={() => { if (!collapsed) toggleMenu(item.path, isOpen); }}
          className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
            collapsed ? "justify-center" : ""
          } ${
            isActive
              ? "text-white"
              : `${textInactive} ${hoverBg}`
          }`}
          style={activeStyle}
          data-testid={`sidebar-nav-${item.path.replace("/", "")}`}
        >
          <item.icon size={20} className="min-w-[20px]" />
          {!collapsed && (
            <>
              <span className="truncate">{item.label}</span>
              <ChevronDown
                size={16}
                className={`ml-auto transition-transform duration-200 ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </>
          )}
        </button>
      );

      if (collapsed) {
        return (
          <Popover
            key={item.path}
            open={flyout === item.path}
            onOpenChange={(o) => setFlyout(o ? item.path : null)}
          >
            <PopoverTrigger asChild>
              <div
                onMouseEnter={() => openFlyout(item.path)}
                onMouseLeave={closeFlyoutSoon}
              >
                {parentEl}
              </div>
            </PopoverTrigger>
            <PopoverContent
              side="right"
              align="start"
              sideOffset={8}
              onMouseEnter={() => openFlyout(item.path)}
              onMouseLeave={closeFlyoutSoon}
              onOpenAutoFocus={(e) => e.preventDefault()}
              style={{ backgroundColor: "white" }}
              className="p-0 w-auto border text-gray-900 shadow-xl rounded-lg min-w-[240px] max-w-[280px] max-h-[calc(100vh-80px)] overflow-y-auto z-[70] dark:!bg-gray-800 dark:text-white dark:border-gray-700"
            >
              <div className="px-3 py-2 border-b border-gray-100 dark:border-gray-700 sticky top-0 bg-white dark:bg-gray-800 z-10">
                <div className="flex items-center gap-2">
                  <item.icon size={14} className="text-gray-400" />
                  <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">{item.label}</p>
                </div>
              </div>
              <div className="p-1.5">
                <MenuLevel
                  items={item.children}
                  depth={0}
                  location={location}
                  onClose={() => { setFlyout(null); onClose?.(); }}
                  extLinkProps={extLinkProps}
                  badges={badges}
                />
              </div>
            </PopoverContent>
          </Popover>
        );
      }

      return (
        <div key={item.path}>
          {parentEl}
          {/* Sub-items */}
          <div
            className={`overflow-hidden transition-all duration-200 ease-in-out ${
              isOpen ? "max-h-[2000px] opacity-100 mt-1" : "max-h-0 opacity-0"
            }`}
          >
            <div className={`ml-4 pl-4 border-l ${subBorder} space-y-0.5`}>
              {item.children.map((child) => {
                const childActive = location.pathname === child.path
                  || (child.path === "/panels" && location.pathname.startsWith("/panels/"));
                const childHasChildren = child.children && child.children.length > 0;

                if (childHasChildren) {
                  const subOpen = openMenus[child.path] ?? isChildActive(child);
                  const subActive = isChildActive(child);
                  return (
                    <div key={child.path}>
                      <button
                        onClick={() => toggleMenu(child.path, subOpen)}
                        className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-all duration-200 ${
                          subActive ? `${subActiveClass} font-medium` : `${textInactive} ${hoverBg}`
                        }`}
                        data-testid={`sidebar-sub-${child.path.split("/").pop()}`}
                      >
                        <child.icon size={16} className="min-w-[16px]" />
                        <span className="truncate flex-1 text-left">{child.label}</span>
                        <ChevronDown size={14} className={`transition-transform duration-200 ${subOpen ? "rotate-180" : ""}`} />
                      </button>
                      <div className={`overflow-hidden transition-all duration-200 ease-in-out ${subOpen ? "max-h-[2000px] opacity-100 mt-1" : "max-h-0 opacity-0"}`}>
                        <div className={`ml-4 pl-3 border-l ${subBorder} space-y-0.5`}>
                          {child.children.map((sub) => {
                            const subActiveLink = location.pathname === sub.path
                              || (sub.path === "/panels" && location.pathname.startsWith("/panels/"))
                              || (sub.path.startsWith("/reports/ready/") && location.pathname.startsWith(`${sub.path}/`));
                            const subHasChildren = sub.children && sub.children.length > 0;

                            if (subHasChildren) {
                              const leafOpen = openMenus[sub.path] ?? sub.children.some((leaf) => location.pathname === leaf.path || (leaf.path.startsWith("/reports/ready/") && location.pathname.startsWith(`${leaf.path}/`)));
                              return (
                                <div key={sub.path}>
                                  <button
                                    onClick={() => toggleMenu(sub.path, leafOpen)}
                                    className={`w-full flex items-center gap-2.5 px-3 py-1.5 rounded-lg text-sm transition-all duration-200 ${textInactive} ${hoverBg}`}
                                    data-testid={`sidebar-subsub-${sub.path.split("/").pop()}`}
                                  >
                                    <sub.icon size={14} className="min-w-[14px]" />
                                    <span className="truncate flex-1 text-left">{sub.label}</span>
                                    <ChevronDown size={12} className={`transition-transform duration-200 ${leafOpen ? "rotate-180" : ""}`} />
                                  </button>
                                  <div className={`overflow-hidden transition-all duration-200 ease-in-out ${leafOpen ? "max-h-[2000px] opacity-100 mt-0.5" : "max-h-0 opacity-0"}`}>
                                    <div className={`ml-4 pl-2 border-l ${subBorder} space-y-0.5`}>
                                      {sub.children.map((leaf) => {
                                        const leafActiveLink = location.pathname === leaf.path || (leaf.path.startsWith("/reports/ready/") && location.pathname.startsWith(`${leaf.path}/`));
                                        return comEstrela(leaf.path, (
                                          <Link
                                            key={leaf.path}
                                            to={leaf.path}
                                            {...extLinkProps(leaf)}
                                            onClick={onClose}
                                            className={`flex-1 flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-all duration-200 ${
                                              leafActiveLink ? `${subActiveClass} font-medium` : `${textInactive} ${hoverBg}`
                                            }`}
                                            data-testid={`sidebar-leaf-${leaf.path.split("/").pop()}`}
                                          >
                                            <leaf.icon size={12} className="min-w-[12px]" />
                                            <span className="truncate">{leaf.label}</span>
                                          </Link>
                                        ));
                                      })}
                                    </div>
                                  </div>
                                </div>
                              );
                            }

                            if (sub.desativado) {
                              return (
                                <div
                                  key={sub.path}
                                  aria-disabled="true"
                                  data-tip="Em breve — recurso em desenvolvimento"
                                  className={`flex items-center gap-2.5 px-3 py-1.5 rounded-lg text-sm ${textInactive} opacity-60 cursor-not-allowed`}
                                  data-testid={`sidebar-subsub-${sub.path.split("/").pop()}`}
                                >
                                  <sub.icon size={14} className="min-w-[14px]" />
                                  <span className="truncate">{sub.label}</span>
                                  {sub.tag && (
                                    <span
                                      className="ml-auto inline-flex items-center justify-center h-5 px-1.5 rounded-full text-[11px] font-semibold text-[#111827] bg-[#f3f4f6]"
                                      data-testid={`sidebar-tag-${sub.path.split("/").pop()}`}
                                    >
                                      {sub.tag}
                                    </span>
                                  )}
                                </div>
                              );
                            }

                            return comEstrela(sub.path, (
                              <Link
                                key={sub.path}
                                to={sub.path}
                                {...extLinkProps(sub)}
                                onClick={onClose}
                                className={`flex-1 flex items-center gap-2.5 px-3 py-1.5 rounded-lg text-sm transition-all duration-200 ${
                                  subActiveLink ? `${subActiveClass} font-medium` : `${textInactive} ${hoverBg}`
                                }`}
                                data-testid={`sidebar-subsub-${sub.path.split("/").pop()}`}
                              >
                                <sub.icon size={14} className="min-w-[14px]" />
                                <span className="truncate">{sub.label}</span>
                              </Link>
                            ));
                          })}
                        </div>
                      </div>
                    </div>
                  );
                }

                if (child.desativado) {
                  // Tela em desenvolvimento: fica visível, mas sem navegar.
                  return (
                    <div
                      key={child.path}
                      aria-disabled="true"
                      data-tip="Em breve — recurso em desenvolvimento"
                      className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm ${textInactive} opacity-60 cursor-not-allowed`}
                      data-testid={`sidebar-sub-${child.path.split("/").pop()}`}
                    >
                      <child.icon size={16} className="min-w-[16px]" />
                      <span className="truncate">{child.label}</span>
                      <span
                        className="ml-auto inline-flex items-center justify-center h-5 px-1.5 rounded-full text-[11px] font-semibold text-[#111827] bg-[#f3f4f6]"
                        data-testid={`sidebar-tag-${child.path.split("/").pop()}`}
                      >
                        {child.tag}
                      </span>
                    </div>
                  );
                }

                return comEstrela(child.path, (
                  <Link
                    key={child.path}
                    to={child.path}
                    {...extLinkProps(child)}
                    onClick={onClose}
                    className={`flex-1 flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-all duration-200 ${
                      childActive
                        ? `${subActiveClass} font-medium`
                        : `${textInactive} ${hoverBg}`
                    }`}
                    data-testid={`sidebar-sub-${child.path.split("/").pop()}`}
                  >
                    <child.icon size={16} className="min-w-[16px]" />
                    <span className="truncate">{child.label}</span>
                    {badges[child.path] > 0 && (
                      <span
                        className="ml-auto inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-[11px] font-semibold text-[#111827] bg-[#f3f4f6]"
                        data-testid={`sidebar-badge-${child.path.split("/").pop()}`}
                      >
                        {badges[child.path]}
                      </span>
                    )}
                  </Link>
                ));
              })}
            </div>
          </div>
        </div>
      );
    }

    // Simple nav item (no children)
    const link = (
      <Link
        key={item.path}
        to={item.path}
        {...extLinkProps(item)}
        onClick={onClose}
        className={`flex-1 flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
          collapsed ? "justify-center" : ""
        } ${
          isActive
            ? "text-white"
            : `${textInactive} ${hoverBg}`
        }`}
        style={activeStyle}
        data-testid={`sidebar-nav-${item.path.replace("/", "")}`}
      >
        <item.icon size={20} className="min-w-[20px]" />
        {!collapsed && <span className="truncate">{item.label}</span>}
      </Link>
    );

    if (collapsed) {
      return (
        <Tooltip key={item.path}>
          <TooltipTrigger asChild>{link}</TooltipTrigger>
          <TooltipContent side="right" className="font-medium">
            {item.label}
          </TooltipContent>
        </Tooltip>
      );
    }
    return comEstrela(item.path, link);
  };

  return (
    <TooltipProvider delayDuration={0}>
      {open && (
        <div
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={onClose}
          data-testid="sidebar-overlay"
        />
      )}
      <aside
        className={`fixed lg:static inset-y-0 left-0 z-50 h-[100dvh] lg:h-auto shrink-0 ${sidebarW} ${sidebarBg} flex flex-col transform transition-all duration-300 ease-in-out ${
          open ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0`}
        data-testid="sidebar"
      >
        {/* Logo */}
        <div className={`flex items-center justify-center px-4 py-5 min-h-[68px]`}>
          <div className="flex items-center justify-center overflow-hidden">
            <img
              src={collapsed ? "/logo_icon.png" : isDark ? "/logo_dark.png" : "/logo_light.png"}
              alt="AutEM"
              className={collapsed ? "h-10 w-10 rounded-xl object-contain shadow-sm" : "h-[3.25rem] object-contain"}
              data-testid="sidebar-logo"
            />
          </div>
          <button
            className="lg:hidden absolute right-4 text-gray-400 hover:text-gray-600"
            onClick={onClose}
            data-testid="sidebar-close-btn"
          >
            <X size={20} />
          </button>
        </div>

        {/* Nav */}
        <nav className="flex-1 mt-2 px-3 space-y-1 overflow-y-auto lg:overflow-visible">
          {renderFavoritos()}
          {filtrarMenu(items || navItems, permitidos, user).map((item) =>
            renderNavItem(item),
          )}
        </nav>

      </aside>
    </TooltipProvider>
  );
}
